"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoostTier = exports.BoostTerm = void 0;
var BoostTier = exports.BoostTier = /*#__PURE__*/function (BoostTier) {
  BoostTier["BASIC"] = "BASIC";
  BoostTier["PLUS"] = "PLUS";
  BoostTier["PREMIUM"] = "PREMIUM";
  BoostTier["VIP"] = "VIP";
  return BoostTier;
}({});
var BoostTerm = exports.BoostTerm = /*#__PURE__*/function (BoostTerm) {
  BoostTerm["MONTHLY"] = "monthly";
  BoostTerm["YEARLY"] = "yearly";
  return BoostTerm;
}({});